/**
 * Sincroniza tema Tailwick no <html> (classe .dark + data-theme).
 * Usado pelo painel master e pelo app principal.
 */
export function applyHtmlTheme(darkMode) {
	const root = document.documentElement;
	if (darkMode) {
		root.classList.add("dark");
		root.setAttribute("data-theme", "dark");
	} else {
		root.classList.remove("dark");
		root.setAttribute("data-theme", "light");
	}
}

export function clearHtmlTheme() {
	const root = document.documentElement;
	root.classList.remove("dark");
	root.removeAttribute("data-theme");
}
